import React, { useEffect, useState } from "react";
import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import GButton from "components/ui/button/Button";
import AppliesOnCombosModal from "./modals/AppliesOnCombosModal";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CombosTable from "./CombosTable";
import DeleteAppliesModal from "./modals/DeleteAppliesModal";
import { getTimedEventsCombos } from "../services/timedEventsCombosService";

const AppliesOnCombos = () => {
  const id = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [showCombosOfTimedEvents, setShowCombosOfTimedEvents] = useState(false);
  const [showDeleteComboModal, setShowDeleteComboModal] = useState(null);

  const combos = useSelector((state) => state.timedEventsCombos);

  useEffect(() => {
    dispatch(getTimedEventsCombos(id.id));
  }, [dispatch, id]);

  return (
    <Box>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        flexWrap="wrap"
        mb={6}
      >
        <Text color="text" textTransform="capitalize">
          {t("pages.timedEvents.applies_on_combos")}
        </Text>

        <GButton
          title={t("pages.timedEvents.add_combos")}
          bg="light"
          color="text"
          fontSize="14px"
          border="1px solid"
          borderColor="border"
          hover={{ bg: "light" }}
          onClick={() => setShowCombosOfTimedEvents(true)}
        />
      </Flex>

      {combos.isLoading ? (
        <Spinner />
      ) : combos.data?.length === 0 ? (
        <Flex
          p={4}
          bg="white"
          alignItems="center"
          justifyContent="center"
          color="text"
          textTransform="capitalize"
          boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
          borderRadius={6}
        >
          {t("pages.branches.no_data")}
        </Flex>
      ) : combos.data?.length > 0 ? (
        <CombosTable
          combosOfTimedEvent={combos.data}
          handleDelete={(combo) => setShowDeleteComboModal(combo)}
        />
      ) : (
        <Flex
          p={4}
          bg="white"
          alignItems="center"
          justifyContent="center"
          color="text"
          textTransform="capitalize"
          boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
          borderRadius={6}
        >
          {t("pages.branches.no_data")}
        </Flex>
      )}

      {showCombosOfTimedEvents && (
        <AppliesOnCombosModal
          onClose={() => setShowCombosOfTimedEvents(false)}
        />
      )}
      {showDeleteComboModal && (
        <DeleteAppliesModal
          id={showDeleteComboModal}
          onClose={() => setShowDeleteComboModal(null)}
          type="Combo"
        />
      )}
    </Box>
  );
};

export default AppliesOnCombos;
